import { render, staticRenderFns } from "./TermAcceptanceModal.vue?vue&type=template&id=10a72410&scoped=true&"
import script from "./TermAcceptanceModal.vue?vue&type=script&lang=js&"
export * from "./TermAcceptanceModal.vue?vue&type=script&lang=js&"
import style0 from "./TermAcceptanceModal.vue?vue&type=style&index=0&id=10a72410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a72410",
  null
  
)

export default component.exports